<template>
  <div class="hs-section-header">
    <div class="left">{{title}}</div>
    <div v-if="showBtnText" class="right" @click="$emit('input', !value)">
      <span class="text">{{value && btnText[1] ? btnText[1] : btnText[0]}}</span>
      <span class="icon" :class="{up: value}" :style="{backgroundImage: `url(${require('@/assets/image/base/arrow/icons_16pt_unfold.svg')})`}"></span>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showBtnText: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: Array,
      default: () => {
        return [Vue.prototype.$t('Unfold'), Vue.prototype.$t('PackUp')]
      }
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-section-header
  @extend .flex-between
  @extend .hs-font-subtitle-big
  width 100%
  background linear-gradient(180deg, #FCE9E3 0%, #FFFFFF 100%)
  padding 16px 12px
  color $color_black_900
  >.left
    width 100%
    font-weight 500
  >.right
    @extend .flex-start
    @extend .hs-font-overline-1
    color $color_black_800
    flex-shrink 0
    line-height normal
    >.icon
      width 16px
      height 16px
      background-size 100% 100%
      background-repeat no-repeat
      animation 0.3s all
      &.up
        transform rotate(180deg)
</style>
